import { render, staticRenderFns } from "./Agradecimiento.vue?vue&type=template&id=523b0cbd&"
import script from "./Agradecimiento.vue?vue&type=script&lang=js&"
export * from "./Agradecimiento.vue?vue&type=script&lang=js&"
import style0 from "./Agradecimiento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports